import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AsideToggleDirective} from './aside.directive';
import {
  NAV_DROPDOWN_DIRECTIVES,
  NavDropdownDirective,
  NavDropdownToggleDirective,
} from './nav-dropdown.directive';
import {
  MobileSidebarClose,
  MobileSidebarSpacerClose,
  MobileSidebarToggleDirective,
  SidebarMinimizeDirective,
  SidebarOffCanvasCloseDirective,
  SidebarToggleDirective,
} from './sidebar.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    AsideToggleDirective,
    NavDropdownDirective,
    NavDropdownToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    MobileSidebarClose,
    MobileSidebarSpacerClose,
    MobileSidebarToggleDirective,
    SidebarMinimizeDirective,
    SidebarOffCanvasCloseDirective,
    SidebarToggleDirective,
  ],
  exports: [
    AsideToggleDirective,
    NavDropdownDirective,
    NavDropdownToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    MobileSidebarClose,
    MobileSidebarSpacerClose,
    MobileSidebarToggleDirective,
    SidebarMinimizeDirective,
    SidebarOffCanvasCloseDirective,
    SidebarToggleDirective,
  ],
})
export class LayoutDirectivesModule {}
